<!--
 * @Author: DY
 * @Date: 2020-08-18 16:29:27
 * @LastEditTime: 2021-11-18 10:08:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_test\src\views\salesTerminal\productionRatio\selectRatio.vue
-->
<template>
    <v-touch
        @swiperight="swiperright"
        class="wrapper"
    >
        <div class="selectRatio">
            <van-nav-bar
                title="选择试验配比"
                left-text="关联配比"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <template v-for="(item,index) in listData">
                                <li :key="index" :class="{'active': selectIndex == index}" @click="selectMatching(item, index)">
                                    <span class="cornerMarker iconfont iconjiaobiao">
                                        <i class="iconfont iconduigou"></i>
                                    </span>
                                    <h4>{{ item.experiment_formula_name }}</h4>
                                    <p class="number">
                                        配合比编号：{{ item.line_experiment_formula_number || item.experiment_formula_number }}
                                    </p>
                                    <div class="grade">
                                        <span>{{ item.strength_grade_name }}</span>
                                        <span>{{ item.impervious_name }}</span>
                                        <span>{{ item.antifreeze_name }}</span>
                                        <span>{{ item.flexural_name }}</span>
                                    </div>
                                    <div class="requirement">
                                        <div>
                                            <h5>特殊要求</h5>
                                            <p>{{ item.special_require_name }}</p>
                                        </div>
                                        <div>
                                            <h5>设计容重</h5>
                                            <p v-if="selectRatioType == 0">
                                                {{ item.experiment_volume_weight }}
                                            </p>
                                            <p v-if="selectRatioType == 1">
                                                {{ item.design_volume_weight }}
                                            </p>
                                        </div>
                                        <div>
                                            <h5>砂率</h5>
                                            <p>{{ item.sand_rate }}</p>
                                        </div>
                                        <div>
                                            <h5>水胶比</h5>
                                            <p>{{ item.water_binder_ratio }}</p>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
            <footer>
                <button @click="cancelSelect">
                    取消
                </button>
                <button @click="confirmSelect">
                    确认
                </button>
            </footer>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 选择配比
    name: 'select-ratio',
    components: {},
    props: {},
    data() {
        return {
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否加载完数据
            finished: false,
            // 上拉索引
            count: 0,
            // 列表数据
            listData: [],
            // 列表总条数
            total: 0,
            // 选择配比类型（0实验配比，1原实验配比）
            selectRatioType: null,
            // 请求参数
            parameter: {},
            // 当前选中下标
            selectIndex: 0,
            // 当前选中数据
            selectData: {},
        };
    },
    created() {
        this.selectRatioType = this.$route.params.selectRatioType;
        this.parameter = JSON.parse(JSON.stringify(this.$route.params));
        delete this.parameter.selectRatioType;
    },
    mounted() {},
    activited() { },
    update() { },
    beforeRouteUpdate() { },
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 下拉刷新
        onRefresh() {
            this.count = 1;
            this.listData = [];
            this.finished = false;
            this.getInit();
        },
        // 上拉加载更多
        onLoad() {
            this.count++;
            this.getInit();
        },
        // 初始化页面数据
        getInit() {
            let getUrl = '';
            if (this.selectRatioType) {
                getUrl = '/interfaceApi/production/standardformula/formula_list';
            } else {
                getUrl = '/interfaceApi/production/experimentformula/choose_formula_list';
            }
            let newParameter = '';
            for (const key in this.parameter) {
                newParameter += key + '=' + this.parameter[key] + '&';
            }
            this.$axios
                .get(`${getUrl}?${newParameter}pageindex=${this.count}&pagesize=4`)
                .then(res => {
                    this.total = res.total;
                    if (this.listData.length < 1) {
                        this.selectData = res.rows[0];
                        this.listData = res.rows;
                        this.finished = false;
                    } else {
                        this.listData.push(...res.rows);
                    }
                    if (this.listData.length === this.total) {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 选择试验配比
        selectMatching(data, index) {
            this.selectData = data;
            this.selectIndex = index;
        },
        // 取消选择
        cancelSelect() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 确认选择
        confirmSelect() {
            if (Object.keys(this.selectData).length > 0) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: 'correlationRatio',
                    params: {
                        selectMatchingData: this.selectData,
                    },
                });
                this.$router.go(-1);
            } else {
                this.$toast('请先选择配比！');
            }
        },
    },
    filter: {},
    computed: {},
    watch: {},
};
</script>

<style lang="stylus" scoped>
.selectRatio
    height 100%
    section
        padding 15rpx
        height calc(100% - 84rpx)
        overflow scroll
        -webkit-overflow-scrolling touch
        .list
            li
                height 145rpx
                border 1px solid #D7D7D7
                border-radius 4px
                position relative
                overflow hidden
                padding 15rpx
                margin-bottom 15rpx
                &.active
                    box-shadow 1px 1px 4px 0px rgba(85,136,241,0.5)
                    border 2px solid rgba(84,165,251,1)
                    .cornerMarker
                        color  rgba(84,165,251,1)
                .cornerMarker
                    position absolute
                    width 40rpx
                    height 40rpx
                    top 0
                    right 0
                    color #D7D7D7
                    &:before
                        font-size 40rpx
                        line-height 40rpx
                        position absolute
                        top 0
                    i
                        font-size 16rpx
                        font-weight 600
                        position absolute
                        top 4rpx
                        right 4rpx
                        color #fff
                h4
                    font-size 16rpx
                    line-height 16rpx
                    margin-bottom 10rpx
                    color #333333
                .number
                    font-size 14rpx
                    line-height 14rpx
                    margin-bottom 10rpx
                    color #666666
                .grade
                    overflow hidden
                    margin-bottom 10rpx
                    span
                        float left
                        width 60rpx
                        text-align center
                        font-size 12rpx
                        line-height 20rpx
                        margin-right 10rpx
                        &:nth-of-type(1)
                            color #5588F1
                            background rgba(85,136,241,0.06)
                        &:nth-of-type(2)
                            color #FA8436
                            background rgba(250,132,54,0.06)
                        &:nth-of-type(3)
                            color #00B4C6
                            background rgba(33,189,204,0.06)
                        &:nth-of-type(4)
                            color #866BEE
                            background rgba(134,107,238,0.06)
                .requirement
                    overflow hidden
                    div
                        float left
                        width calc(25% - 10rpx)
                        height 40rpx
                        background rgba(85,136,241,0.06)
                        margin-right 10rpx
                        text-align center
                        h5
                            font-size 10rpx
                            line-height 22rpx
                            color #666666
                        p
                            font-size 14rpx
                            line-height 14rpx
                            color #5588F1
                            white-space nowrap
                            overflow hidden
                            text-overflow ellipsis
    footer
        height 40rpx
        button
            width 50%
            height 40rpx
            background #fff
            font-size 16rpx
            color #E50C0D
            border 1px solid #E50C0D
            &:before
                padding-right 5rpx
            &:nth-of-type(2)
                background #E50C0D
                color #fff
</style>
